<script setup>
const props = defineProps({
    icon: {
        required: false,
        type: String,
    },
    text: {
        required: false,
        type: String,
    },
    color: {
        required: false,
        type: String,
        default: 'black',
    }
});

const color = {
    primary: 'bg-primary/10 text-primary border-primary/20',
    black: 'bg-black/10 text-black border-black/20',
    danger: 'bg-danger/10 text-danger border-danger/20',
    warning: 'bg-warning/10 text-warning border-warning/20',
    info: 'bg-info/10 text-info border-info/20',
};
</script>

<template>
    <div class="flex items-center py-1 text-xs font-medium px-4 rounded-md w-fit border" :class="[color[props.color]]">
        <component v-if="icon" :is="`icon-${icon}`" class="size-3" />
        <span v-if="text">{{ text }}</span>
    </div>
</template>
